import React from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export default function NumberedHeader(props) {
  const color = props.color ?? 'black';
  const height = 25;
  return _jsxs("div", {
    children: [_jsx("div", {
      style: {
        display: 'inline-block',
        width: height,
        height: height,
        lineHeight: height + 'px',
        color: color,
        border: '2px solid ' + color,
        borderRadius: height,
        fontSize: 18,
        fontWeight: 'bold',
        textAlign: 'center',
        boxSizing: 'content-box',
        userSelect: 'none'
      },
      children: props.number
    }), _jsx("div", {
      style: {
        display: 'inline-block',
        marginLeft: 5,
        height: height,
        lineHeight: height + 'px',
        color: color,
        fontSize: 16,
        fontWeight: 'bold'
      },
      children: props.text
    })]
  });
}